module.exports = __webpack_public_path__ + "img/1w.94e1f00a.svg";